import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontSize: 12,
        fontFamily: "Helvetica",
        color: "#282828",
        lineHeight: 1.6,
    },

    logo: {
        width: 65,
        marginBottom: 24,
    },

    date: {
        marginBottom: 20,
    },

    heading: {
        fontSize: 22,
        fontWeight: "bold",
        marginBottom: 16,
    },

    paragraph: {
        marginBottom: 12,
    },

    highlight: {
        backgroundColor: "rgba(218, 14, 41, 0.1)",
        paddingVertical: 14,
        paddingHorizontal: 16,
        marginTop: 18,
        marginBottom: 22,
        textAlign: "center",
    },

    section: {
        marginBottom: 22,
        flexDirection: "row",
        alignItems: "center",
    },

    sectionLabel: {
        fontWeight: "bold",
        marginBottom: 4,
        marginRight: 4,
    },

    value: {
        fontSize: 12,
        marginBottom: 4,
    },

    signatureImage: {
        maxHeight: 100,
        width: 150,
        marginTop: 8,
    },
});

type Props = {
    itemId: string;
    shipmentId: string;
    name: string;
    address: string;
    date: string;
    signature?: string;
};

const ReceiptPdf = ({
    itemId,
    shipmentId,
    name,
    address,
    date,
    signature,
}: Props) => {

    console.log('Generating PDF with signature:', signature);

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                {/* LOGO */}
                <Image
                    style={styles.logo}
                    src="/static/img/cml-mobile-logo.png"
                />

                <Text style={styles.date}>{date}</Text>

                <Text style={styles.heading}>Dear Customer,</Text>

                <Text style={styles.paragraph}>
                    This is a proof of delivery / statement of final status for the
                    shipment with item id number {shipmentId}.
                </Text>

                <Text style={styles.paragraph}>Thank you for choosing CML.</Text>

                {/* highlight box */}
                <View style={styles.highlight}>
                    <Text>
                        Your shipment {shipmentId} was delivered on {date}
                    </Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.sectionLabel}>Signed by:</Text>
                    <Text style={styles.value}>{name || 'N/A'}</Text>
                </View>

                {/* signature */}
                {signature && (
                    <View style={styles.section}>
                        <Text style={styles.sectionLabel}>Signature:</Text>
                        <Image
                            style={styles.signatureImage}
                            src={signature}
                        />
                    </View>
                )}

                <View style={styles.section}>
                    <Text style={styles.sectionLabel}>Delivery Address:</Text>
                    <Text style={styles.value}>{address || 'N/A'}</Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.sectionLabel}>Shipment Status:</Text>
                    <Text style={styles.value}>Delivered</Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.sectionLabel}>Item ID:</Text>
                    <Text style={styles.value}>{itemId}</Text>
                </View>

            </Page>
        </Document>
    );
};

export default ReceiptPdf;